<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="document_type_list" class="elevation-1 mytable" dense
                :search="search" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Document Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="10" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>

                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Document Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field 
                      v-model="editedItem.documentType" 
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Aadhaar Card, Pan Card ':'For example :: Aadhaar Card, Pan Card'"
                      :filled="editedIndex==-1?false:true"
                      label="Document Type"
                      :error="errorMsg.documentType?true:false"
                      :error-messages="errorMsg.documentType?'Required':''"
                    ></v-text-field>
                  </v-col> -->
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="document_type_super_master"
                                                        v-model="editedItem.document_type_super_master"
                                                        label="Select Document Type"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.documentType" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="
                                                         editedIndex == -1
                                ? 'For example ::Aadhaar Card, Pan Card '
                                : 'noneditable'
                            " label="Document Type"></v-text-field>
                                                </v-col>
                                                <!-- <v-col cols="12" >Document Type
                          <v-select dense
                            v-model="editedItem.documentType"
                            :items="document_type_super_master"                            
                            item-text="document_type_super_master_id"
                            item-value="id"
                            persistent-hint
                            :disabled="editedIndex != -1"
                             :hint="editedIndex==-1?'For example :: Aadhaar Card, Pan Card ':'noneditable'"
                            :filled="editedIndex==-1?false:true"
                            :error="errorMsg.documentType?true:false"
                            :error-messages="errorMsg.documentType?'Required':''"
                          ></v-select>
                        </v-col> -->


                                            </v-row>

                                            <v-row dense>
                                                <v-col v-if="editedIndex != -1">
                                                    <v-text-field rounded dense outlined label="Allowed Extentions"
                                                        persistent-hint hint="Allowed Extentions"
                                                        v-model="editedItem.ext" name="ext"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12" v-if="editedIndex == -1">
                                                    <v-text-field rounded dense outlined label="Allowed Extentions"
                                                        persistent-hint hint="Allowed Extentions"
                                                        v-model="editedItem.ext" name="ext"></v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row dense>
                                                <v-col v-if="editedIndex != -1">
                                                    <v-text-field rounded dense outlined label="Allowed Size(Bytes)"
                                                        persistent-hint hint="Allowed Size(Bytes)"
                                                        v-model="editedItem.sizelimit" name="sizelimit"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12" v-if="editedIndex == -1">
                                                    <v-text-field rounded dense outlined label="Allowed Size(Bytes)"
                                                        persistent-hint hint="Allowed Size(Bytes)"
                                                        v-model="editedItem.sizelimit" name="sizelimit"></v-text-field>
                                                </v-col>

                                            </v-row>

                                            <v-row dense>
                                                <v-col v-if="editedIndex != -1">
                                                    <v-text-field rounded dense outlined label="Allowed Height"
                                                        persistent-hint hint="Allowed Height"
                                                        v-model="editedItem.height" name="height"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12" v-if="editedIndex == -1">
                                                    <v-text-field rounded dense outlined label="Allowed Height"
                                                        persistent-hint hint="Allowed Height"
                                                        v-model="editedItem.height" name="height"></v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row dense>
                                                <v-col v-if="editedIndex != -1">
                                                    <v-text-field rounded dense outlined label="Allowed Width"
                                                        persistent-hint hint="Allowed Height" v-model="editedItem.width"
                                                        name="width"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12" v-if="editedIndex == -1">
                                                    <v-text-field rounded dense outlined label="Allowed Width"
                                                        persistent-hint hint="Allowed Height" v-model="editedItem.width"
                                                        name="width"></v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.dimention" color="success"
                                                        label="Is Dimentions Required.?"></v-checkbox>
                                                </v-col>
                                            </v-row>

                                            <v-row dense>
                                                <v-col v-if="editedIndex == -1">
                                                    <v-checkbox dense v-model.trim="newcheckbox" color="success"
                                                        label="Document not present in above list? Add new here..."></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12" v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field v-model.trim="editedItem.newdocument" persistent-hint
                                                        hint="For example :: PAN, Birth Certificate, Child Passport, Residence proof"
                                                        label="New Document" ref="newdocument"></v-text-field>
                                                </v-col>

                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-checkbox dense
                                                        v-model="editedItem.is_compulsary_for_admission_form"
                                                        color="success"
                                                        label="Is Compulsary for Admission Form?"></v-checkbox>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-checkbox dense v-model="editedItem.editable_by_parent"
                                                        color="success" label="Editable By Parent"></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="newcheckbox">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="saveNewDocument">Save New Document</v-btn>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:[`item.dimention`]="{ item }">
                    <span v-if="item.dimention">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.is_compulsary_for_admission_form="{ item }">
                    <span v-if="item.is_compulsary_for_admission_form">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.editable_by_parent="{ item }">
                    <span v-if="item.editable_by_parent">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                    <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
                </template>
                <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            overlay: false,
            errorMsg: {
                documentType: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            newdocument: "",
            // extraBreadcrumbItems: [
            //     { text: "Document Type Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style2",
            newcheckbox: false,
            document_type_super_master: null,
            headers: [
                {
                    text: "Document Type",
                    align: "left",
                    sortable: false,
                    value: "documentType",
                },
                {
                    text: "Allowed Extentions",
                    align: "left",
                    sortable: false,
                    value: "ext",
                },
                {
                    text: "Allowed Size(Bytes)",
                    align: "left",
                    sortable: false,
                    value: "sizelimit",
                },
                 {
                    text: "Is Dimentions Required?",
                    align: "left",
                    sortable: true,
                    value: "dimention",
                },
                {
                    text: "Allowed Height",
                    align: "left",
                    sortable: true,
                    value: "height",
                },
                {
                    text: "Allowed Width",
                    align: "left",
                    sortable: true,
                    value: "width",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                
                {
                    text: "Is Compulsary for Admission Form?",
                    align: "center",
                    sortable: true,
                    value: "is_compulsary_for_admission_form",
                },
                {
                    text: "Is Editable By Parent?",
                    align: "center",
                    sortable: true,
                    value: "editable_by_parent",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            document_type_list: [],
            editedIndex: -1,
            // addedItem:{
            //   document_type_super_master:'',
            //   is_compulsary_for_admission_form:''
            // },
            editedItem: {
                // document_type_super_master: "",
                id: "",
                documentType: "",
                newdocument:"",
                isactive: true,
                is_compulsary_for_admission_form: "",
                editable_by_parent: "",
                ext: "",
                sizelimit: "",
                dimention:"",
                height:"",width:""
            },
            defaultItem: {
                id: "",
                documentType: "",
                newdocument:"",
                isactive: true,
                is_compulsary_for_admission_form: "",
                editable_by_parent: "",
                ext: "",
                sizelimit: "",
                 dimention:"",
                height:"",width:""
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Document Type" : "Edit Document Type";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            //   initialize () {

            //   },
               hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            saveNewDocument() {
                if (this.editedItem.newdocument == null || this.editedItem.newdocument == "") {
                    this.showSnackbar("#b71c1c", "Please add Document!");
                    this.$refs["newdocument"].focus();
                    return;
                }
                let data = {
                    newdocument: this.newdocument,
                    
                };
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/addNewDocument",this.editedItem)
                    .then((res) => {
                         (this.newdocument = ""),(this.is_compulsary_for_admission_form =""),(this.editable_by_parent =""),(this.newcheckbox = false), (this.overlay = false);
                        if (res.data.status.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Category Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "Category Already Present!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                         this.showSnackbar("#b71c1c", "Something went Wrong...!");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
                this.close();
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/documentType")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)

                            if ((this.load = true)) {
                                this.overlay = false;
                                this.document_type_list = res.data.document_type_list;
                                this.document_type_super_master = res.data.document_type_super_master;
                            }
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            editItem(item) {
                this.editedIndex = this.document_type_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            // deleteItem (item) {
            //   const index = this.document_type_list.indexOf(item)
            //   confirm('Are you sure you want to delete this item?') && this.document_type_list.splice(index, 1)
            // },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
                this.newcheckbox = false;
                this.newdocument = "";
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/editDocumentType", this.editedItem)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    //window.alert(res.data.msg)
                                    this.onLoad();
                                    // Object.assign(this.document_type_list[this.editedIndex], this.editedItem)
                                }
                                this.showSnackbar("#4caf50", "Document Type Updated Successfully..."); // show snackbar on success
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                        this.close();
                    }
                } else {
                    axios
                        .post("/AdmissionMaster/saveDocumentType", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                //window.alert(res.data.status.code)
                                // this.document_type_list.push(this.addedItem)
                                this.showSnackbar("#4caf50", "Document Type Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                //window.alert(res.data.status.code)
                                this.showSnackbar("#b71c1c", "Document Type Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }, //save()
            isValidated() {
                if (this.editedItem.documentType) {
                    return true;
                } else {
                    if (!this.editedItem.documentType) {
                        this.errorMsg.documentType = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>

